import type { Ref } from "vue";
import { useHeadlessCultureState } from "../states/headlessStates";

export function useCurrentCulture (): Ref<string | null> {
  return useHeadlessCultureState();
}
